import { Component } from '@angular/core';

@Component({
    selector: 'lynkd-pattern-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {}
